import { defineAnimationStyles } from '@chakra-ui/react';

export const animationStyles = defineAnimationStyles({
  'slide-fade-in': {
    value: {
      transformOrigin: 'var(--transform-origin)',
      '&[data-placement^=top]': {
        animationName: 'slide-from-bottom, fade-in',
      },
      '&[data-placement^=bottom]': {
        animationName: 'slide-from-top, fade-in',
      },
      '&[data-placement^=left]': {
        animationName: 'slide-from-right, fade-in',
      },
      '&[data-placement^=right]': {
        animationName: 'slide-from-left, fade-in',
      },
    },
  },
  'slide-fade-out': {
    value: {
      transformOrigin: 'var(--transform-origin)',
      '&[data-placement^=top]': {
        animationName: 'slide-to-bottom, fade-out',
      },
      '&[data-placement^=bottom]': {
        animationName: 'slide-to-top, fade-out',
      },
      '&[data-placement^=left]': {
        animationName: 'slide-to-right, fade-out',
      },
      '&[data-placement^=right]': {
        animationName: 'slide-to-left, fade-out',
      },
    },
  },
  /**
   * Лента, которая появляется сверху вниз, а не одним кадром.
   *
   * Ставится на КОНТЕЙНЕР списка, задержку получает каждый прямой ребёнок. Иначе шаг пришлось
   * бы считать в разметке и передавать индекс в карточку, а карточка про своё место в списке
   * знать не должна.
   *
   * 55ms - середина вилки, в которой ступенька уже читается, а список ещё не кажется медленным.
   * На шести строках хвост набегает 275ms, поэтому дальше шестой задержку не наращиваем: в
   * длинной ленте нижние строки иначе ждали бы секунду ради украшения.
   *
   * Только для списков, которые приходят целиком и не виртуализованы. В `DiscoverList` строки
   * монтируются и снимаются на каждой прокрутке (Virtuoso), и появление там играло бы заново
   * при каждом движении пальца - это не стаггер, а мигание.
   *
   * Движение отключается по «уменьшить движение»: остаётся проявление, уходит сдвиг. Так велит
   * сам стандарт - меньше движения, а не ноль обратной связи.
   */
  'stagger-children': {
    value: {
      '& > *': {
        animationName: 'rise-in',
        animationDuration: 'moderate',
        animationTimingFunction: 'ease-out',
        animationFillMode: 'backwards',
      },
      '& > *:nth-child(2)': { animationDelay: '55ms' },
      '& > *:nth-child(3)': { animationDelay: '110ms' },
      '& > *:nth-child(4)': { animationDelay: '165ms' },
      '& > *:nth-child(5)': { animationDelay: '220ms' },
      '& > *:nth-child(n+6)': { animationDelay: '275ms' },
      '@media (prefers-reduced-motion: reduce)': {
        '& > *': { animationName: 'fade-in', animationDelay: '0ms' },
      },
    },
  },
  'scale-fade-in': {
    value: {
      transformOrigin: 'var(--transform-origin)',
      animationName: 'scale-in, fade-in',
    },
  },
  'scale-fade-out': {
    value: {
      transformOrigin: 'var(--transform-origin)',
      animationName: 'scale-out, fade-out',
    },
  },
});
